export default __webpack_public_path__ + "static/media/splashscreen.afff4510.png";